import { concat, fn } from '@ember/helper';
import didInsert from '@ember/render-modifiers/modifiers/did-insert';
import { service } from '@ember/service';
import { dasherize } from '@ember/string';
import Component from '@glimmer/component';

import { t } from 'ember-intl';
import sortableGroup from 'ember-sortable/modifiers/sortable-group';
import sortableHandle from 'ember-sortable/modifiers/sortable-handle';
import sortableItem from 'ember-sortable/modifiers/sortable-item';
import svgJar from 'ember-svg-jar/helpers/svg-jar';
import sortBy from 'lodash-es/sortBy';

import Checkbox from 'umg-ember-backend/components/ui/form/field/checkbox';
import { getBem } from 'umg-ember-backend/utils/get-bem';

import styles from './styles.module.css';

const bem = getBem(styles);

export default class ShopListComponent extends Component {
  // Services
  @service fetch;

  // Getter and setter
  get sortedShops() {
    // Filter archived shops (without a name)
    const filteredJobs = this.args.model.shops?.filter((shop) => !!shop.name);

    return sortBy(filteredJobs, ['isActive:desc', 'position', 'name']);
  }

  // Actions
  reorderItems = (items) => {
    items.forEach((item, index) => (item.position = index));

    this.args.model.shops = items;
  };

  addMissingShops = async () => {
    let model = this.args.model;
    let apiShops = await this.fetch.request('/mlpShops');

    if (!model.shops?.length) {
      model.shops = apiShops;
    } else {
      let position = model.shops.length;

      for (const apiShop of apiShops) {
        const shops = await model.shops;
        const exists = shops.find((shop) => shop.shopId === apiShop.shopId);

        if (!exists) {
          apiShop.isActive = false;
          apiShop.position = position++;

          model.shops.push(apiShop);
        }
      }
    }
  };

  // Template
  <template>
    <div
      class={{(bem)}}
      {{didInsert this.addMissingShops}}
      {{sortableGroup groupName='shop' onChange=this.reorderItems}}
      ...attributes
    >
      {{#each this.sortedShops as |shop|}}
        <div class={{bem 'shop'}} {{sortableItem groupName='shop' model=shop}}>
          <div class={{bem 'handle'}} {{sortableHandle}}>
            {{svgJar 'drag' class=(bem 'drag-indicator')}}
          </div>
          <Checkbox
            @fieldId={{concat 'shop-' shop.id}}
            @style='check'
            @isChecked={{shop.isActive}}
            @isDisabled={{@disabled}}
            @onChange={{fn (mut shop.isActive)}}
          />
          <label for={{concat 'shop-' shop.id}} class={{bem 'name'}}>
            {{shop.name}}
          </label>
          <div class={{bem 'type'}}>
            {{t (concat 'models.' (dasherize shop.type))}}
          </div>
        </div>
      {{/each}}
    </div>
  </template>
}
